export default __webpack_public_path__ + "static/card-visa-gold@3x-f4d8af4118d58aa0302847302e520c62.png";